<template>
  <div class="headerHappinessTips">
    <h1>{{ $t('happinessTips.label.listHappinessTips.title') }}</h1>

    <v-data-table
      :headers="headers"
      :items="happinessTips"
      :header-props="{ class: 'red-header' }"
      :search="searchTerm"
      :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
      :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
    >
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto">
            <v-text-field
              :label="$t('label.search.title')"
              :placeholder="$t('label.search.text')"
              append-icon="mdi-magnify"
              dense
              outlined
              class="col-md-5"
              @input="search"
            ></v-text-field>

            <div class="btn">
              <addHappinessTips :category="category" />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:[`item.title`]="{ item }">
        <span class="custom-font">{{ item.title }}</span>
      </template>

      <template v-slot:[`item.happinessCategoryTipsName`]="{ item }">
        <span class="custom-font">{{ item.happinessCategoryTipsName }}</span>
      </template>

      <template v-slot:[`item.active`]="{ item }">
        <span class="custom-font">{{ item.active ? $t('novelties.label.status.option1') : $t('novelties.label.status.option2') }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div class="actions">
          <detailHappinessTips
            :happinessTipsProps="item"
            style="margin-left: 1vh"
            ><v-btn icon x-large dark text>
              <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
          </detailHappinessTips>

          <v-btn
            class="btnDetails"
            icon
            x-large
            dark
            text
            @click="confirmDeleteHappinessTips(item.idTip)"
            style="background-color: transparent; margin-left: 1vh"
          >
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <v-card class="container justify-content-between align-items-center">
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <v-col cols="12" md="12" sm="6">
          <img
            src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
            alt="Imagen de bienvenida"
            class="custom-img"
          />
        </v-col>
        <h2 class="custom-title">{{ $t('happinessTips.label.delete.title') }}</h2>

        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-textarea
              color="secondary"
              :label="'*'+$t('label.observation.title')" 
              :placeholder="$t('label.observation.text')"
              v-model="formData.observation"
              :counter="100"
              :maxlength="100"
              required
              :rules="messageRules"
              underlined
              @input="changeObservation"
            ></v-textarea>
          </v-col>
          <v-btn
            large
            block
            rounded
            :color="isSubmitting ? 'primary' : 'grey'"
            class="mb-4 custom-btn"
            style="color: white; border-radius: 50px"
            :disabled="!isSubmitting"
            @click="deleteHappinessTips()"
          >
            {{ $t('button.delete') }}
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import addHappinessTips from "@/views/happiness-tips/pages/add_happiness-tips/components/form_add_happiness_tips_component.vue";
import detailHappinessTips from "@/views/happiness-tips/pages/detail_happiness-tips/detail_happiness_tips_page.vue";
import EventBus from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  HAPPINESS_TIPS_M,
  GET_HAPPINESS_TIPS,
  ACTION_GET_HAPPINESS_TIPS,
  ACTION_DELETE_HAPPINESS_TIPS,
} from "@/views/happiness-tips/store/types/types.js";

export default {
  name: "listHappinessTipsComponent",
  components: {
    addHappinessTips,
    detailHappinessTips,
  },

  props: {
    category: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      dialog: false,
      isSubmitting: false,
      tipId: null,
      searchTerm: "",
      messageRules: [(v) => !!v || this.$t('label.observation.required')],
      formData: {},
    };
  },

  async mounted() {
    const categoryId = this.category ? this.category.happinessCategoryTipsId : null;
    await this.getActionHappinessTips(categoryId);

    EventBus.$on("reload-happiness-tips", async () => {
      await this.reloadHappinessTips();
    });

    EventBus.$on("reload-update-happiness-tips", async () => {
      await this.reloadHappinessTips();
    });
  },

  methods: {
    ...mapActions({
      getActionHappinessTips: `${HAPPINESS_TIPS_M}${ACTION_GET_HAPPINESS_TIPS}`,
      deleteActionHappinessTips: `${HAPPINESS_TIPS_M}${ACTION_DELETE_HAPPINESS_TIPS}`,
    }),

    async reloadHappinessTips() {
      const categoryId = this.category ? this.category.happinessCategoryTipsId : null;
      await this.getActionHappinessTips(categoryId);
    },

    search() {
      this.searchTerm = event.target.value;
    },

    closeDialog() {
      EventBus.$emit("close-dialog");
      this.dialog = false;
      window.location.reload();
    },

    async confirmDeleteHappinessTips(tipId) {
      this.dialog = true;
      this.formData.tipId = tipId;
    },

    changeObservation() {
      if (this.formData.observation.trim()) {
        this.isSubmitting = true;
      } else {
        this.isSubmitting = false;
      }
    },

    async deleteHappinessTips() {
      Swal.fire({
        title: i18n.t('label.delete.title'),
        text: i18n.t('label.delete.text'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: i18n.t('button.delete.accept'),
        cancelButtonText: i18n.t('button.delete.cancel'),
        confirmButtonColor: "#6E17A5",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            console.log("? [COMPONENTE] Enviando a Vuex:", this.formData);
            await this.deleteActionHappinessTips(this.formData);
            await Swal.fire({
              position: "top-end",
              icon: "success",
              title: i18n.t('happinessTips.actionDeleteHappinessTips.success'),
              showConfirmButton: false,
              timer: 2500,
            });
            this.closeDialog();
          } catch (error) {
            console.error("Error al eliminar:", error);
            Swal.fire({
              icon: "error",
              text: i18n.t('label.errorServiceDelete'),
            });
          }
        } else {
          await Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
          this.closeDialog();
        }
      });
    },
  },

  computed: {
    ...mapGetters({
      happinessTips: [`${HAPPINESS_TIPS_M}${GET_HAPPINESS_TIPS}`],
    }),

    headers() {
      return [
        {
          text: this.$t('happinessTips.label.table.title'),
          value: "title",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('happinessTips.label.table.category'),
          value: "happinessCategoryTipsName",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('tips.label.table.status'),
          value: "active",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>

<style lang="css" scoped>
.headerHappinessTips h1 {
  margin-bottom: 30px;
}

.headerHappinessTips {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.actions v-icon {
  font-size: 24px;
}
.custom-font {
  font-size: 20px;
}

body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.btnDetails .v-icon {
  color: #6e17a5;
  margin-bottom: 19px;
}

.actions {
  display: flex;
}

img {
  width: 3rem;
  height: 3rem;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  justify-items: center;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.small-x {
  font-size: smaller;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6e17a5;
}

.custom-btn {
  border-radius: 50px;
  padding: 12px;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }
  .custom-font {
    font-size: 13px;
  }
  img {
    margin-top: 18px;
    margin-bottom: auto;
    width: 3rem;
    height: 3rem;
  }
}

@media screen and (min-width: 414px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }
  h2 {
    font-size: 2vh;
  }
  .custom-font {
    font-size: 13px;
  }
  img {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 3rem;
    height: 3rem;
  }
}
</style>
